<div id="step-image-loader" class="">
    <div mat-dialog-title>
        <div class="row">
            <div class="col-md-10">
                <h3>Select from S3</h3>
            </div>
            <div class="col-md-2">
                <span style="cursor: pointer;" class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
            </div>
        </div>
    </div>
    <div mat-dialog-content>
        <div class="row col-12 mt-3 mb-3">
            <div>
                <mat-radio-group aria-label="Content Type" (change)="onContentTypeChange($event)" [(ngModel)]="contentType" name="featureType"
                    required #contentTypeText="ngModel">Content Type
                    <mat-radio-button value="internal">Internal</mat-radio-button>
                    <mat-radio-button value="external">External</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <div class="image-gallery">
            <div class="image-container">
                <label class="option-item" *ngFor="let x of imageList | paginate : {
                        itemsPerPage: pageSize,
                        currentPage: page,
                        totalItems: count
                      } let i = index;">
                    <mat-card class="image-gallery-card" [ngStyle]="{'padding': imageInfo === 'Feature' ? '20px':'10px'}">
                        <mat-checkbox [(ngModel)]="x.checked" [hidden]="imageInfo === 'Feature'" class="image-checkbox" id="{{ 'check' + i }}" (change)="onImageClick(x,i,$event);"
                            name="troubleshootingCheckBox" style="position: absolute;top:0px;left:0px;z-index:2;">
                        </mat-checkbox>
                        <!--  <input [(ngModel)]="selectedFeatureIcon.checked" type="radio" id="{{ 'radio' + i }}" [hidden]="imageInfo === 'step'" style="position: absolute;top: 0;left: 0;"
                            name="drone" (change)="onImageClick(x,i,$event);"> -->
                        <!--  <mat-radio-group name="flavors" [(ngModel)]="x.checked" [hidden]="imageInfo === 'step'">
                            <mat-radio-button name="drone" style="position: absolute;top: 0;left: 0;" id="{{ 'radio' + i }}" (change)="onImageClick($event,x,i);"></mat-radio-button>
                        </mat-radio-group> -->
                        <mat-checkbox [(ngModel)]="x.checked" [hidden]="imageInfo === 'step'" class="image-checkbox" id="{{ 'check' + i }}" (change)="onImageClick(x,i,$event);"
                            name="troubleshootingCheckBox" style="position: absolute;top:0px;left:0px;z-index:2;">
                        </mat-checkbox>
                        <div class="option-inner-item">
                            <div class="tickmark"></div>
                            <div class="icon" style="width: 100%;height:100%;">
                                <img *ngIf="imageInfo === 'Feature'" alt="" [src]="x.image" width="100%" height="100%">
                                <img *ngIf="imageInfo === 'step'" alt="" [src]="x.image" width="100%" height="100%">
                            </div>
                        </div>
                    </mat-card>
                </label>
            </div>
        </div>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <div class="row col-12 mb-3">
            <pagination-controls class="col-12" style="text-align: center;" previousLabel="Prev" nextLabel="Next" responsive="false"
                (pageChange)="handlePageChange($event)"></pagination-controls>
        </div>
        <div class="row col-12 mb-3 center-alignment" *ngIf="imageInfo === 'step'" [hidden]="selectedImageList.length === 0" style="width:500px;height: 400px;">
            <carousel class="carousel-container">
                <slide *ngFor="let slide of selectedImageList; let index=index" class="carousel-slide">
                    <img [src]="slide" alt="image slide" class="carousel-img">
                </slide>
            </carousel>
        </div>
        <div class="row col-12 mb-3 center-alignment" *ngIf="imageInfo === 'Feature'" [hidden]="selectedImageList.length === 0">
            <mat-card class="image-gallery-card">
                <img [src]="selectedImageList[0]" alt="image slide" class="feature-img">
            </mat-card>
        </div>
        <div class="row col-12 mt-4 center-alignment">
            <span>
                <button class="btn btn-default" (click)="onSelect()">Ok</button>
            </span>
            <span class="ml-2">
                <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
            </span>
        </div>
    </div>

</div>